<!-- 表格组件 -->
<template>
  <div class="table-container">
    <div v-if="showText" class="mb10 textInfoContainer">
      <slot name="textInfo"></slot>
    </div>
    <Search
      ref="searchRef"
      v-if="showSearchIcon && !isLineSearch && false"
      :showSearch="showSearch"
      :columns="columns"
      :searchAttrName="searchAttrName"
      @onSearch="onSearch"
    />
    <el-row v-if="showFun" :gutter="10" class="mb8">
      <template v-if="showSearchComponents">
        <!-- 老版高级搜索 -->
        <JsonSearch
          ref="jsonSearchRef"
          :tableColumns="tableColumns"
          :itemSearch="true"
          :showSelectSearch="showSelectSearch"
          :searchAttrName="searchAttrName"
          @onCustomSearch="onSearch"
        >
          <template #searchBefore>
            <slot name="searchBefore"></slot>
          </template>
          <template #selectSearch>
            <slot name="selectSearch"></slot>
          </template>
        </JsonSearch>
        <!-- <template v-if="isLineSearch"> -->
        <template v-if="false">
          <!-- 行内搜索 -->
          <Search
            ref="searchRef"
            v-if="isLineSearch && device === 'desktop'"
            style="height: 30px"
            :showSearch="showSearch"
            :columns="columns"
            :searchAttrName="searchAttrName"
            @onSearch="onSearch"
          />
        </template>
        <template v-else>
          <el-divider
            direction="vertical"
            border-style="solid"
            content-position="center"
            v-show="showDivider"
          />
          <slot name="funBtn"></slot>
        </template>
      </template>
      <div style="height: 31px">
        <slot name="henderExtend"></slot>
      </div>
      <RightToolBar
        ref="rightToolBarRef"
        v-model:showSearch="showSearch"
        v-model:showAdvancedSearch="showAdvancedSearch"
        v-model:showDownload="showDownload"
        :showSearchIcon="false"
        :showAdvancedSearchIcon="false"
        :showAdvancedSearchType="showAdvancedSearchType"
        :showRefresh="showRefresh"
        :columns="columns"
        :tableName="tableName"
        @queryTable="refresh"
        @updateTableCol="handleUpdateTableCol"
      />
    </el-row>
    <Table
      ref="tableRef"
      :data="data"
      :columns="tableColumns"
      :height="height"
      :maxHeight="maxHeight"
      :showIndex="showIndex"
      :lazy="lazy"
      :load="load"
      :rowKey="rowKey"
      :loading="loading"
      :showSummary="showSummary"
      :summaryProperty="summaryProperty"
      :isSelect="isSelect"
      :isRadio="isRadio"
      :isExpand="isExpand"
      :childColumns="childColumns"
      :tableName="tableName"
      :searchTextDict="searchTextDict"
      :disabledBtn="disabledBtn"
      :infiniteScroll="infiniteScroll"
      :sortable="sortable"
      @expandOpen="handleExpandOpen"
      @search="handleQuery"
      @scrollSearch="handleScrollSearch"
      @saveCol="handleSaveCol"
      @changeSelect="changeSelect"
      @changeInput="changeInput"
      @onSelectChange="onSelectChange"
      @updateColOrder="updateColOrder"
    />
    <!--       :search-text="searchText" -->
    <div style="position: relative" v-if="!infiniteScroll">
      <Pagination
        v-show="(showPagination === undefined && total > 0) || showPagination"
        :total="total"
        :pagerCount="pagerCount"
        :layout="layout"
        v-model:page="pageParam.pageIndex"
        v-model:limit="pageParam.pageSize"
        @pagination="handleQuery"
      />
    </div>
    <!-- 高级搜索 -->
    <!-- 新版高级搜索 未完成 -->
    <!-- <AdvancedSearch
      :showAdvancedSearchType="showAdvancedSearchType"
      v-model:showAdvancedSearch="showAdvancedSearch"
      :columns="tableColumns"
      :advancedSearchAttrName="advancedSearchAttrName"
    /> -->
    <!--  老版高级搜索 -->
    <!-- 下载 -->
    <Download
      v-model:showDownload="showDownload"
      :showDownloadType="showDownloadType"
      :exportDataUrl="exportDataUrl"
      @onExportData="handleExportData"
    />
  </div>
</template>

<script setup>
import RightToolBar from "@/components/Element/Table/RightToolbar";
import Table from "@/components/Element/Table/Table";
import Pagination from "@/components/Element/Table/Pagination";
import Search from "@/components/Element/Table/Search";
import Download from "./Download";
import AdvancedSearch from "./AdvancedSearch";
import { ref, onMounted, computed, useSlots } from "vue";
import useAppStore from "@/store/modules/app";
import { doExportData } from "./tableFun";
import JsonSearch from "./AdvancedSearch/JsonSearch";

const device = computed(() => useAppStore().device);
const slots = useSlots();
const props = defineProps({
  showSearchIcon: {
    // 是否显示搜素
    type: Boolean,
    default: false,
  },
  showSearchComponents: {
    // 是否显示搜索组件
    type: Boolean,
    default: true,
  },
  showSelectSearch: {
    // 是否显示下拉搜索（产品、仓库）
    type: Boolean,
    default: false,
  },
  isCreateSearch: {
    // 是否创建表格后搜索一次
    type: Boolean,
    default: true,
  },
  isLineSearch: {
    // 是否为行内搜索，为行内搜索则上方的搜索不显示
    type: Boolean,
    default: false,
  },
  showAdvancedSearchIcon: {
    // 是否显示高级搜素图标
    type: Boolean,
    default: true,
  },
  /* 高级搜索类型 （drawer抽屉、dialog 对话框） */
  showAdvancedSearchType: {
    type: String,
    default: "drawer",
  },
  /* 是否显示下载图标 */
  showDownloadIcon: {
    type: Boolean,
    default: true,
  },
  /* 显示下载组件的类型（drawer抽屉、dialog 对话框） */
  showDownloadType: {
    type: String,
    default: "dialog",
  },
  sortable: {
    // 是否可以排序表格
    type: [Boolean, String],
    default: "custom",
  },
  /** 是否显示刷新按钮 */
  showRefresh: {
    type: Boolean,
    default: true,
  },
  showFun: {
    // 是否显示工具栏
    type: Boolean,
    default: true,
  },
  showText: {
    // 是否显示文字信息
    type: Boolean,
    default: false,
  },
  searchAttrName: {
    // 可以搜索的属性
    type: Array,
    default: () => [],
  },
  advancedSearchAttrName: {
    // 高级搜索可以搜索的属性
    type: Array,
    default: () => [],
  },
  data: {
    // 数据
    type: Array,
    default: () => [],
  },
  columns: {
    // 类配置
    type: Array,
    default: () => [],
  },
  tableName: {
    // 表格的名字
    required: false,
    type: String,
    default: "",
  },
  height: {
    // 表格高度
    type: [Number, String],
    default: "100%",
  },
  maxHeight: {
    type: [Number, String],
    default: null,
  },
  total: {
    // 数据总数
    type: Number,
    default: 0,
  },
  pageSize: {
    // 每页数量
    type: Number,
    default: 10,
  },
  pageTotal: {
    // 分页总数
    type: Number,
    default: 1,
  },
  loading: {
    // 加载状态
    type: Boolean,
    default: false,
  },
  lazy: {
    // 是否懒加载
    type: Boolean,
    default: false,
  },
  load: {
    // 懒加载回调
    type: Function,
    default: () => {},
  },
  rowKey: {
    // 行 key
    required: false,
    type: String,
    default: "",
  },
  showIndex: {
    // 是否显示序号
    type: Boolean,
    default: true,
  },
  isSelect: {
    // 是否可以选择
    type: Boolean,
    default: false,
  },
  isRadio: {
    // 是否为单选
    type: Boolean,
    default: false,
  },
  isExpand: {
    // 是否可以展开
    type: Boolean,
    default: false,
  },
  childColumns: {
    // 可以展开子表格的类数据
    type: Array,
    default: () => [],
  },
  customParamsFun: {
    // 自定义参数函数
    required: false,
    type: Function,
    default: (data) => ({}),
  },
  customJsonParamsFun: {
    // 自定义参数函数
    required: false,
    type: Function,
    default: (data) => [],
  },
  /** 导出全部数据的url */
  exportDataUrl: {
    type: String,
    default: "",
  },
  disabledBtn: {
    // 输入、选择、按钮是否disabled
    type: Boolean,
    default: false,
  },
  /* 展示合计行 */
  showSummary: {
    type: Boolean,
    default: false,
  },
  /* 合计属性 */
  summaryProperty: {
    type: String,
    default: "",
  },
  // 移动端页码按钮的数量端默认值5
  pagerCount: {
    type: Number,
    default: document.body.clientWidth < 992 ? 5 : 7,
  },
  layout: {
    type: String,
    default: "total, sizes, prev, pager, next, jumper",
  },
  /* 无限滚动搜索 */
  infiniteScroll: {
    type: Boolean,
    default: false,
  },
  /* 显示分页 */
  showPagination: {
    type: Boolean,
    default: undefined,
  },
});
const emits = defineEmits([
  "onSelectChange",
  "onSearch",
  "onScrollSearch",
  "expandOpen",
  "changeSelect",
  "changeInput",
]);

const jsonSearchRef = ref(null);
const rightToolBarRef = ref(null);
const searchRef = ref(null);
const tableRef = ref(null);
// 是否显示搜索
const showSearch = ref(true);

// 是否显示高级搜索
const showAdvancedSearch = ref(false);

// 是否显示下载
const showDownload = ref(false);

// 表格动态列
const tableColumns = ref(props.columns);

const pageParam = ref({
  pageIndex: 1,
  pageSize: props.pageSize,
});

// 刷新表格数据
const refresh = () => {
  handleQuery();
};

const searchTextDict = ref({});
const handleQuery = () => {
  searchTextDict.value = jsonSearchRef.value?.getSearchText();
  emits("onSearch", getSearchParams());
};

let scrollSearchIndex = 1;
const handleScrollSearch = () => {
  if (scrollSearchIndex > props.pageTotal) return;
  emits("onScrollSearch", {
    pageIndex: scrollSearchIndex,
    pageSize: props.pageSize,
  });
  scrollSearchIndex += 1;
};

const onSearch = () => {
  if (props.infiniteScroll) {
    scrollSearchIndex = 1;
    handleScrollSearch();
  } else {
    pageParam.value = { pageIndex: 1, pageSize: props.pageSize };
    handleQuery();
  }
};

/**
 * 保存类配置
 */

const handleSaveCol = () => {
  rightToolBarRef.value && rightToolBarRef.value.saveCol(true);
};

/**
 * 搜索参数
 */
const getSearchParams = () => {
  // 获取高级搜索组件的参数
  let jsonSearchParams = jsonSearchRef.value?.getSearchParams();
  let whereSql = [];
  whereSql = whereSql.concat(props.customJsonParamsFun());
  if (!jsonSearchParams) {
    jsonSearchParams = {};
  } else {
    if ("whereSql" in jsonSearchParams) {
      whereSql = whereSql.concat(JSON.parse(jsonSearchParams.whereSql));
    }
  }
  if (whereSql.length > 0) {
    jsonSearchParams.whereSql = JSON.stringify(whereSql);
  }
  let searchParams = {};
  if (searchRef.value) {
    searchParams = searchRef.value.getSearchParams();
  }
  const customParams = props.customParamsFun();
  // 获取排序参数
  const sortParams = tableRef.value.getSortParams();
  const reParams = {
    ...searchParams,
    ...pageParam.value,
    ...customParams,
    ...jsonSearchParams,
  };
  if (sortParams) {
    reParams.sort = sortParams;
  }
  return reParams;
};

// 展开行
const handleExpandOpen = (row) => {
  emits("expandOpen", row);
};
const changeSelect = (row) => {
  emits("changeSelect", row);
};
const changeInput = (row) => {
  emits("changeInput", row);
};
const onSelectChange = (vals) => {
  emits("onSelectChange", vals);
};

const updateColOrder = (param) => {
  rightToolBarRef.value.updateColOrder(param);
};

// 导出数据
const handleExportData = (radio) => {
  let allDataParams = {};

  if (radio === 3) {
    allDataParams = {
      ...getSearchParams(),
      pageIndex: 1,
      pageSize: props.total + 100,
    };
  }
  doExportData(
    radio,
    tableColumns.value,
    tableRef.value.getSelectedRows(),
    props.data,
    allDataParams,
    props.exportDataUrl,
  );
};

/**
 * 调整列的显示和隐藏和排序
 */

const handleUpdateTableCol = (cols) => {
  tableColumns.value = cols;
};
const showDivider = ref(false);
onMounted(() => {
  if (slots.funBtn) {
    showDivider.value = true;
  }
  if (props.isCreateSearch) {
    handleQuery();
  }
});

/** 表格组件供外界调用的函数 */
defineExpose({
  reLazyLoad: (data) => {
    // 刷新懒加载数据
    tableRef.value.reLazyLoad(data);
  },
  removeRowByEvent: (event) => {
    // 根据单元格文本删除节点
    tableRef.value.removeRowByEvent(event);
  },
  onSearch: onSearch, // 搜索
  getSelectedRows: () => {
    // 获取选中的行
    return tableRef.value.getSelectedRows();
  },
  cleanSelect: () => {
    // 清除选中
    tableRef.value.cleanSelect();
  },
  // 导出数据
  exportData: (code) => {
    handleExportData(code);
  },
  // 获取table ref
  getTableRef: () => {
    return tableRef.value.getTableRef();
  },
});
</script>

<style lang="scss" scoped>
.textInfoContainer {
  text-align: center;
}
:deep(.el-divider) {
  height: 32px;
  margin-right: 20px;

  //line-height: 32px;
}
:deep(.el-table .el-table__body-wrapper) {
  order: 1;
}
</style>
@/components/Element/Table/tableFun./tableFun.js
